import { API_KEYS_TO_SKIP } from "./SuccessChecklistModal.constants";

export const buildInitialChecklist = (checklistData) => {
  if (!checklistData?.length) return {};
  return checklistData.reduce((acc, item) => {
    acc[item.value] = { id: item.id, checked: false };
    return acc;
  }, {});
};

export const transformApiResponseToChecklist = (data) => {
  if (!data) return {};
  return Object.entries(data).reduce((acc, [key, value]) => {
    if (API_KEYS_TO_SKIP.includes(key)) return acc;
    acc[key] = { id: data.id, checked: value };
    return acc;
  }, {});
};
